import React from 'react'

const Heatmap = () => {
  const heatmap =
    '<iframe src="https://iframe.money2020.timecodelab.com/" width="100%" height="800" style="border: none; background: black; display: block;"></iframe>'

  return <div dangerouslySetInnerHTML={{ __html: heatmap }} />
}

export default Heatmap
